export default "__VITE_ASSET__nSv07w4d__"